/**
 * The ITLamb logo — the same squares as `public/favicon.svg`, inline so its
 * colours come from the theme. Decorative: the link around it carries the
 * name.
 */
export function BrandMark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      className="brand-mark"
      aria-hidden="true"
    >
      <g className="brand-mark-base">
        <rect x="6" y="6" width="16" height="16" rx="3" />
        <rect x="24" y="6" width="16" height="16" rx="3" />
        <rect x="42" y="6" width="16" height="16" rx="3" />
        <rect x="24" y="42" width="16" height="16" rx="3" />
        <rect x="42" y="42" width="16" height="16" rx="3" />
      </g>
      <rect
        x="24"
        y="24"
        width="16"
        height="16"
        rx="3"
        className="brand-mark-accent"
      />
    </svg>
  );
}
